module.exports = __webpack_public_path__ + "img/PS2.f9f4fa09.png";